export const errorMessages = {
  400: "Invalid request. Please check your input.",
  401: "Your session has expired. Please login again.",
  403: "You don't have permission to access this resource.",
  404: "The requested resource was not found.",
  408: "Request timeout. Please try again.",
  500: "Internal server error. Please try again later.",
  502: "Server is temporarily unavailable. Please try again later.",
  503: "Service unavailable. Please try again later.",
  504: "Gateway timeout. Please try again later.",
  default: "An unexpected error occurred. Please try again."
};

export function getErrorMessage(error) {
  // First check if backend provided a message
  if (error.response?.data?.message) {
    return error.response.data.message;
  }
  
  // If no backend message, use our status code mapping
  if (error.response) {
    const status = error.response.status;
    return errorMessages[status] || errorMessages.default;
  }
  
  // For network errors
  if (error.request) {
    return "Unable to connect to server. Please check your internet connection.";
  }
  
  // For any other errors
  return error.message || errorMessages.default;
} 